import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { downloadInvoice } from "../features/invoice/invoiceSlice";

const Invoice = ({ orderId }) => {
  const dispatch = useDispatch();
  const [isDownloading, setIsDownloading] = useState(false);
  const { error } = useSelector((state) => state.invoice);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      await dispatch(downloadInvoice(orderId)).unwrap();
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div>
      <button
        onClick={handleDownload}
        className="invoice ms-3"
        disabled={isDownloading}
      >
        {isDownloading ? `Downloading Invoice${orderId.slice(-4)}...` : "Download Invoice"}
      </button>
      {error && <p className="error">Error: {error}</p>}
    </div>
  );
};

export default Invoice;
